import React from 'react'
import styles from './EmploymentStatus.module.css'
import { FormTitle } from '../../../Common/FormTitle'
import { ChoicesButton } from '../../../Common/CtaButton/ChoicesButton'
import { OtherButton } from '../../../Common/CtaButton/OtherButton'
import { useAbTestGtm } from '../../../../../hooks/useAbTestGtm'

export const EmploymentStatus = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()

    return (
        <div className={styles.wrapper}>
            <div>
                <FormTitle
                    formTitleText='雇用形態はなんですか？'
                    dataViewLabel={dataViewLabel('EF_StepForm_雇用形態')}
                    dataClickLabel={dataClickLabel('EF_StepForm_雇用形態-戻る')}
                />
                <div className={styles.selectionWrapper}>
                    <ChoicesButton
                        imageSrc='/foodslaboEf/img/step10/people-full-time.png'
                        imageAlt='正社員画像'
                        text='正社員'
                        formKey={['userResumesAttributes', 'employmentId']}
                        formValue={[0, 1]}
                        displayFormKey={'employment'}
                        displayFormValue={'正社員'}
                        dataClickLabel={dataClickLabel(
                            'EF_StepForm_雇用形態-正社員'
                        )}
                    />
                    <ChoicesButton
                        imageSrc='/foodslaboEf/img/step10/people-contract.png'
                        imageAlt='契約社員画像'
                        text='契約社員'
                        formKey={['userResumesAttributes', 'employmentId']}
                        formValue={[0, 2]}
                        displayFormKey={'employment'}
                        displayFormValue={'契約社員'}
                        dataClickLabel={dataClickLabel(
                            'EF_StepForm_雇用形態-契約社員'
                        )}
                    />
                    <OtherButton
                        text='パート・アルバイト'
                        formKey={['userResumesAttributes', 'employmentId']}
                        formValue={[0, 3]}
                        displayFormKey={'employment'}
                        displayFormValue={'パート・アルバイト'}
                        dataClickLabel={dataClickLabel(
                            'EF_StepForm_雇用形態-パート・アルバイト'
                        )}
                    />
                </div>
            </div>
        </div>
    )
}
